export enum SearchOperatorEnum {
  EQUAL = '==',
  LESS = '<',
  GREATER = '<',
  LESS_EQUAL = '<=',
  GREATER_EQUAL = '>='
}
